export const gridSpacing10 = {
    xs: '10px',
    sm: '10px',
    lg: '10px',
    xl: '10px',
};

export const gridSpacing15 = {
    xs: '15px',
    sm: '15px',
    lg: '15px',
    xl: '15px',
};

export const gridSpacing20 = {
    xs: '20px',
    sm: '20px',
    lg: '20px',
    xl: '20px',
};

export const gridSpacing30 = {
    xs: '30px',
    sm: '30px',
    lg: '30px',
    xl: '30px',
};
export const gridSpacing40 = {
    xs: '40px',
    sm: '40px',
    lg: '40px',
    xl: '40px',
};

export const full_ColumnGrid = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 };

export const doubleSM_ColumnGrid = { xs: 12, sm: 6, md: 6, lg: 6, xl: 6 };
export const doubleMD_ColumnGrid = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
export const doubleLG_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 6,
};

export const doubleXL_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 6,
};

export const thirdXL_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 4,
    xl: 4,
};

export const thirdXL_DoubleLG_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 4,
};
export const singleLG_DoubleSM_ColumnGrid = {
    xs: 12,
    sm: 6,
    md: 6,
    lg: 3,
    xl: 3,
};

export const singleLG_DoubleMD_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 3,
    xl: 3,
};

export const singleXL_DoubleLG_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 3,
    xxl: 3,
};

export const singleXXL_DoubleLG_ColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 6,
    xl: 6,
    xxl: 3,
};

export const singleMD_ColumnGrid = { xs: 12, sm: 12, md: 3, lg: 3, xl: 3 };
